import {$events} from "../helpers/events";
import {$dom} from "../helpers/dom";
import {isElement, preventDefault} from '../helpers/_utilities';
import is from 'is_js';
import variables from '../variables';

const {
	ready,
	get,
	getAll,
	attr,
	each,
	removeClass,
	addClass,
	html
} = $dom;

function postAjax(url, data, success) {
	let params = typeof data == 'string' ? data : Object.keys(data).map(
		function (k) {
			return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
		}
	).join('&');

	let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
	xhr.open('POST', url);
	xhr.onreadystatechange = function () {
		if (xhr.readyState > 3 && xhr.status === 200) {
			success(xhr.response);
		}
	};
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.send(params);
	return xhr;
}

ready(function () {
	$events.delegate
		.on("click tap", '.js-lazyload-button', function (event) {
			preventDefault(event);
			const
				containerSelector = get(attr(this, 'data-page-container-selector')),
				pageCount = Number(attr(this, 'data-page-count')),
				pageHref = attr(this, 'data-page-href')
			;

			let pageCurrent = Number(attr(this, 'data-page-current'));

			if (is.number(pageCurrent) && is.number(pageCount) && is.string(pageHref)) {
				pageCurrent++;
				attr(this, 'data-page-current', pageCurrent);

				if (pageCurrent >= pageCount) this.style.display = 'none';

				if (pageCurrent <= pageCount) {
					postAjax(pageHref + pageCurrent, {action: "getNextPage"}, function (data) {

						each(getAll('li.page__pagination-item'), paginationItem => {
							removeClass(paginationItem, variables.classNames.active);
							if (attr(paginationItem, 'data-number') === pageCurrent)
								addClass(paginationItem, variables.classNames.active);
						});

						if (isElement(containerSelector)) html(containerSelector, html(containerSelector) + data);
					});
				}
			}
		})
		.on(variables.customEventNames.articleSearchDone, window, ({detail}) => {
			postAjax(location.href, {action: "getCoincidence",search: detail.value }, function (data) {
				let notify = get(".js-search-form-notify span");
				if(isElement(notify)){
					html(notify,data);
				}
				window.currentPage.articleSearch.checkSuggestion();
			});
			window.currentPage.articleSearch.checkSuggestion();
		})
		.on(variables.customEventNames.rangeChanged, window, ({detail}) => {
				const {boundInput, values, noUiSlider} = detail;

				if (window.hasOwnProperty('smartFilter')) {
					window.smartFilter.keyup(boundInput);
				}


				/*console.log(boundInput);
				console.log(values);
				console.log(noUiSlider);*/
		})

	;

});
